import { z } from 'zod';

export const getEnglishIqResultV1RequestSchema = z.object({
  shareId: z
    .string()
    .min(6)
    .max(64)
    .regex(/^[A-Za-z0-9_-]+$/u),
});

export type IGetEnglishIqResultV1Request = z.infer<typeof getEnglishIqResultV1RequestSchema>;
